export default {
	root: {
		fontFamily: 'Prompt'
	}
};
